/** Per-mode display colors matching the vanilla frontend's `MODE_COLORS`. */
export const MODE_COLORS: Record<string, string> = {
  'S-Bahn': '#008d4f',
  'U-Bahn': '#0067ad',
  Bus: '#a5027d',
  Tram: '#be1414',
  Regional: '#f39100',
  Ferry: '#00a4db',
};

/** Fallback color when a leg's mode is unknown or missing. */
export const DEFAULT_LINE_COLOR = '#58a6ff';

/** Muted color for walking legs. */
export const WALKING_LINE_COLOR = '#8b949e';

/**
 * Minimal shape {@link lineColor} needs from a journey leg. Widens to accept
 * any leg-like input without depending on the full ts-rs `LegJson` type.
 */
export interface LegColorInput {
  type?: string | null;
  mode?: string | null;
  route_color?: string | null;
}

/**
 * Color for a leg: walking → muted gray, transit → GTFS `route_color` (if
 * present) or mode default, unknown → generic primary.
 */
export function lineColor(journeyLeg: LegColorInput): string {
  if (journeyLeg.type === 'walking') return WALKING_LINE_COLOR;
  if (journeyLeg.route_color) return `#${journeyLeg.route_color}`;
  const modeColor =
    journeyLeg.mode === null || journeyLeg.mode === undefined
      ? undefined
      : MODE_COLORS[journeyLeg.mode];
  if (modeColor) return modeColor;
  return DEFAULT_LINE_COLOR;
}
